import { BranchErrorService, BranchService } from '@alpha-core/platform-ui';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { BranchStateService } from '../services/branch-state.service';

export const branchValidationGuard: CanActivateFn = async (route, state) => {
    const router = inject(Router);
    const branchService = inject(BranchService);
    const branchStateService = inject(BranchStateService);
    const branchErrorService = inject(BranchErrorService);

    const projectId = route.params['projectId'] || route.queryParams['projectId'];
    const branch = route.queryParams['branch'] || 'main';

    // Skip validation for 'main' branch or if no projectId
    if (branch === 'main' || !projectId?.trim()) {
        return true;
    }

    try {
        const branchExists = await firstValueFrom(branchService.validateBranch(projectId, branch));

        if (!branchExists) {
            // Set branch state to main
            branchStateService.setBranch('main');

            // Store the invalid branch name to show dialog after redirect completes
            branchErrorService.setInvalidBranch(branch);

            // Build redirect URL with branch=main
            const newQueryParams = { ...route.queryParams, branch: 'main' };
            const urlPath = state.url.split('?')[0];
            const segments = urlPath.split('/').filter((s) => s);

            return router.createUrlTree(segments.length > 0 ? segments : ['/'], {
                queryParams: newQueryParams,
            });
        }
    } catch (error) {
        console.error('Error validating branch:', error);
        // On error, redirect to main branch as fallback
        branchStateService.setBranch('main');
        branchErrorService.setInvalidBranch(branch);

        const newQueryParams = { ...route.queryParams, branch: 'main' };
        const urlPath = state.url.split('?')[0];
        const segments = urlPath.split('/').filter((s) => s);

        return router.createUrlTree(segments.length > 0 ? segments : ['/'], {
            queryParams: newQueryParams,
        });
    }

    return true;
};
